import {inject, Injectable, OnDestroy} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {Task} from '../../api';
import {SseEvent} from '../sse/sse-event.model';
import {SseService} from '../sse/sse.service';

@Injectable({
  providedIn: 'root'
})
export class TaskSseService implements OnDestroy {
  private sseService = inject(SseService);

  private taskEventsSubject = new Subject<SseEvent<Task>>();
  public taskEvents$ = this.taskEventsSubject.asObservable();

  private subscription?: Subscription;
  private currentProjectId?: number;

  subscribeToProject(projectId: number): void {
    if (this.currentProjectId === projectId) return;

    this.subscription?.unsubscribe();
    this.currentProjectId = projectId;

    this.subscription = this.sseService
      .listen<Task>(`/tasks/subscribe/${projectId}`)
      .subscribe({
        next: event => this.taskEventsSubject.next(event),
        error: err => console.warn('Task SSE error:', err)
      });
  }

  unsubscribe(): void {
    this.subscription?.unsubscribe();
    this.currentProjectId = undefined;
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }
}
